import { Button } from "@omni/ui/components/Button/button.component";

import { SelectedFacet } from "@/components/Search/SearchResults/StateComponents/SelectedFacets/selectedFacets.types";

type SelectedFacetsComponentProps = {
    selectedFacet: SelectedFacet;
};

const SelectedFacetComponent = ({
    selectedFacet
}: SelectedFacetsComponentProps) => {
    return (
        <Button
            className={"mr-2 mb-2"}
            color={"gray"}
            size="sm"
            onClick={selectedFacet.onClear}
            type={"button"}
        >
            {selectedFacet.label}
            <i className="ml-2 las la-times"></i>
        </Button>
    );
};

export { SelectedFacetComponent };
